<template>
    

    <div class='card purshase-product-info mb-4'>
        
        <div  class='product-name  card-header pointer'>
            <div class="row">
                <div class="col-8">
                    <div class='index' v-if="index > 0"> {{ purshaseProduct.id }} </div>
                    <h6 class='name f6 mt-2 o-60'> {{purshaseProduct.name.replace(/^([^\/]*?)\/.*/,'$1')}} </h6> 
                    <h5 class='name f5'> {{purshaseProduct.name.replace(/^[^\/]*?\//,'')}} </h5> 
                    <hr />
                    <p>
                       comprador: <b> {{purshaseProduct.client.name}} </b> / <a class="white" :href="'mailto:'+purshaseProduct.client.email">{{purshaseProduct.client.email}} </a>
                    </p>
                    <h5>
                       {{ infoTeam }}
                   <!-- <pre>    {{ purshaseProduct }} </pre> -->
                    </h5>
                </div>
                <div class="col-4 h-100 flex align-center">
                   
                    <div :class="'payment-status ' +paymentStatus" v-b-tooltip='paymentStatus'>
                        <icon  icon="money-bill-alt" />
                        <!-- <icon :class="paymentStatus" icon="money-bill-alt" />
                        <icon :class="paymentStatus" icon="money-bill-alt" /> -->
                    </div>
                
                </div>
            </div>
        </div>
        <!-- <div class='card-body'>
            
        </div> -->

    </div>

</template>

<script>
import _ from 'lodash'
export default {
    data(){
        return {
            open:false
            }
    },
    props:{
        purshaseProduct:{
            type:Object
        },
        index:{
            type:Number,
            default:0
        }
    },

    computed:{
        product:function(){
            return this.purshaseProduct.product;
        },
        members:function(){
            return this.purshaseProduct.members;
        },
        team:function(){
            return this.purshaseProduct.team;
        },
        infoTeam:function(){
            let value = ""
            var b = this.purshaseProduct;
            // console.log(this.team)
            //get first info team
            // if( _.has(this.purshaseProduct,'team.infos') ){
                let infos = _.get(this.purshaseProduct,'team.[0].infos');
                    console.log(infos)
                _.forOwn(infos, (v,k)=>{
                    console.log(k)
                    console.log(v)
                    if( !_.isEmpty(v) ){
                        value = v;
                    }
                })
            // }

            return value;

        },
        paymentStatus:function(){

            if(this.purshaseProduct.payed==true || this.purshaseProduct.payedByAdmin==true  ){
                return "payed";
            }else{
                return this.purshaseProduct.paymentStatus
            }
        },
        // needFill:function(){
        //     return this.purshaseProduct.teamDefinitions.needFillOnPurchase;
        // },
    },

    methods:{
        removePurshaseProduct:function(){
            this.$store.commit('OrderStore/removePurchaseProduct',this.purshaseProduct)
        }
    }
}
</script>


<style lang="stylus" scoped >


.payment-status{
    position:absolute;
    right:10px;
    font-size:1.5em;
    &.payed{
        color:green;
    }
    &.waiting{
        color:yellow;
    }
    &.error{
        color:red;
    }
    &.canceled{
        color:red;
    }
}
.product-name{

    position:relative;
    background var(--product-selector-bg-color);

    .index{
        position:absolute;
        width larg = 25px;
        height: larg
        border-radius:25px 0 0 25px;
        left:-(larg);
        top:2px;
        background:var(--product-selector-color)
        line-height: larg;
        color:white;
        font-weight:bolder;
        text-align:center;
        font-size:9px;
        // opacity:0.6;
    }
    .name{
        color:white;
    }
    .delete{
        position:absolute;
        color:white;
        right:15px;
        top:15px;
        opacity:0.9;
        cursor:pointer;
    }    
}

</style>
